import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getData } from '../../../services/fetch-service';

function VideoBoxBallin(props) {
    const { layout, locale, withLinks } = props;
    const [videoBox, setVideoBox] = useState([]);
    const [page, setPage] = useState([]);
    const [url, setUrl] = useState('');

    if (layout === 'default') {
        useEffect(() => {
            getData(`Galery/GetGaleries?MediaGaleriaKategoriaID=2&Layout=${layout}&Gjuha=${locale}&take=1`).then((response) => {
                setVideoBox(response.data.galeriaLista);
                setPage(response.data.page[0]);
                setUrl(`/VideoGalery/${response.data.page[0].pageId}`);
            });
        }, [locale]);
    } else {
        useEffect(() => {
            getData(`Galery/GetGaleries?MediaGaleriaKategoriaID=2&Layout=${layout}&Gjuha=${locale}&take=1`).then((response) => {
                setVideoBox(response.data.galeriaLista);
                setPage(response.data.page[0]);
                setUrl(`/${layout}/VideoGalery/${response.data.page[0].pageId}`);
            });
        }, [locale, layout]);
    }

    const boxes = videoBox.map((item, index) => {
        const path = process.env.REACT_APP_FILESPATH;
        const sourceImage = `${path}${item.media?.mediaEmri}${item.media?.mediaEx}`;
        const image = `<video controls preload="none"><source src="${sourceImage}"></video>`
        return (
            <div key={index} className="galery-home">
                <div className="galery-home-card">
                    <div className="galery-home-info">
                        {/* <div className="galery-home-name">
                            <h3>{item.mediaGaleriaPershkrimi}</h3>
                        </div> */}
                    </div>
                    <div className="galery-home-link">
                        <Link
                            to={url}
                            aria-label="link"
                            name="link"
                            rel="link"
                        >
                            <span>{page.pageName}</span>
                        </Link>
                    </div>
                    <div className={`galery-home-box--${withLinks}`} dangerouslySetInnerHTML={{ __html: item.media?.otherSource === null ? image : item.media?.otherSource }} />
                </div>
            </div>
        );
    });

    return (
        <div className={`block-galery-home--${withLinks}`}>
            <div className="block-galery-box">
                {boxes}
            </div>
        </div>
    );
}

VideoBoxBallin.propTypes = {
    withLinks: PropTypes.oneOf(['default', 'withLinks']),
    layout: PropTypes.oneOf(['default', 'thesari', 'buxheti', 'tatimiNeProne', 'partneriteti', 'socialet', 'puna', 'raportimet', 'pensionet', 'punesimet', 'vleresimi']),
};

VideoBoxBallin.defaultProps = {
    layout: 'default',
    withLinks: 'withLinks',
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(VideoBoxBallin);
